import { useQuery } from '@tanstack/react-query';
import { documents } from '@/utils/api';

export function useDocuments(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['documents', params],
    queryFn: () => documents.getAll(params).then((r) => r.data),
    placeholderData: (prev) => prev,
  });
}

export function useDocumentStats() {
  return useQuery({
    queryKey: ['documents', 'stats'],
    queryFn: () => documents.getStats().then((r) => r.data),
  });
}
